import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

interface FormFieldProps {
  label: string
  htmlFor?: string
  required?: boolean
  error?: string
  hint?: string
  className?: string
  children: ReactNode
}

export function FormField({
  label,
  htmlFor,
  required,
  error,
  hint,
  className,
  children,
}: FormFieldProps) {
  return (
    <div className={cn('space-y-1', className)}>
      {/* Label */}
      <label
        htmlFor={htmlFor}
        className="flex items-center gap-1 text-sm font-medium text-text"
      >
        {label}
        {required && <span className="text-danger">*</span>}
      </label>

      {/* Input wrapper with validation icon */}
      <div className="relative">
        {children}

        {/* Validation icon */}
        {error && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-danger pointer-events-none">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        )}
      </div>

      {/* Error message */}
      {error && (
        <p className="text-sm text-danger flex items-center gap-1">
          {error}
        </p>
      )}

      {/* Hint text (only show if no error) */}
      {hint && !error && (
        <p className="text-sm text-text-muted">{hint}</p>
      )}
    </div>
  )
}

export default FormField
